import Meteri_Logo from "../../assets/restaurant/meteri-logo.png"
import BannerImg from "../../assets/restaurant/BannerBg.png"
import { useCallback, useEffect, useRef, useState } from "react"
import { IoClose } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { RiArrowDownSLine } from "react-icons/ri";
import CustomerLogin from "../../Panels/CustomerPanel/CustomerLogin";
import CustomerRegister from "../../Panels/CustomerPanel/CustomerRegister";
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import LanguageSelection from "../LanguageSelection";

const Banner = (props) => {

  const { showSentence, logo, desc, restaurantId, restaurantName, showModalReg, setShowModalReg } = props;
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('Role');
  const { rest_name } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef();
  const [showModalLogin, setShowModalLogin] = useState(false);
  const [showLoginReg, setShowLoginReg] = useState(false);
  const [isLogin, setIsLogin] = useState({});
  const [userData, setUserData] = useState();
  const [showOptionToggle, setShowOptionToggle] = useState(false);
  const [userType, setUserType] = useState('');
  const { t } = useTranslation();

  const extractTokenFromUrl = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const token = url.searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
    } else {
      console.error('Token parameter not found in the URL.');
    }
  };

  const fetchEndUserData = useCallback(async () => {
    setUserType(role)
    if (role === 'admin' || role === 'restaurant') {
      console.error('This role is not allowed to perform this action.');
      return;
    }
    if (token) {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/enduser`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = response.data;
        setUserData(data);
        localStorage.setItem('Role', 'customer');
        localStorage.setItem("currentRestId", data.restaurant_id);
        localStorage.setItem("type", data.user_type);
        localStorage.setItem("RoleId", data.role_id);
        localStorage.setItem("loginUserId", data.id);
        localStorage.setItem("RoleName", data?.user_type);
        const { protocol, host, pathname } = window.location;
        const cleanedUrl = `${protocol}//${host}${pathname}`;
        window.history.replaceState(null, '', cleanedUrl);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      console.error('No token found in localStorage.');
    }
  }, [apiUrl, role, token]);

  const userLogout = async () => {
    try {
      await axios.post(
        `${apiUrl}/api/v1/end-user/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ).then((response) => {
        if (response.status === 200) {
          localStorage.removeItem("Role");
          localStorage.removeItem("token");
          localStorage.removeItem("currentRestId");
          localStorage.removeItem("loginUserId");
          localStorage.removeItem("type");
          localStorage.removeItem("RoleName");
          localStorage.removeItem("RoleId");
          toast.success(response?.data?.message, { theme: "colored", autoClose: 1000 });
          setIsLogin({})
          setUserData()
          navigate(`/restaurant/${rest_name}`,
            { state: { role: null, token: null, loginUser: false } });
        }
      })
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("Role");
        localStorage.removeItem("token");
        localStorage.removeItem("currentRestId");
        localStorage.removeItem("loginUserId");
        localStorage.removeItem("type");
        localStorage.removeItem("RoleName");
        localStorage.removeItem("RoleId");
        toast.success(err?.response?.data?.message, { theme: "colored", autoClose: 1000 });
        setIsLogin({})
        setUserData()
        navigate(`/restaurant/${rest_name}`,
          { state: { role: null, token: null, loginUser: false } });
      }
    }
  }

  const getGreeting = () => {
    if (isLogin?.loginUser && isLogin?.token && isLogin?.role === "customer") {
      return `Hi, ${isLogin.cusFName} ${isLogin.cusLName}`;
    } else if (userData) {
      return `Hi, ${userData.firstname} ${userData.lastname}`;
    }
    return null;
  };

  const toggleDropdown = () => {
    setShowOptionToggle((prevState) => !prevState);
  };

  const handleLogout = () => {
    userLogout();
    setShowModalLogin(false);
    setShowModalReg(false);
  };

  useEffect(() => {
    const loginUser = location?.state;
    if (loginUser) {
      setIsLogin(loginUser);
    }
  }, [location.state]);

  useEffect(() => {
    extractTokenFromUrl();
  }, [fetchEndUserData]);

  useEffect(() => {
    fetchEndUserData();
  }, [fetchEndUserData]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOptionToggle(false);
      }
    };
    document.addEventListener("click", handleClickOutsideClick);

    return () => {
      document.removeEventListener("click", handleClickOutsideClick);
    };
  }, []);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLoginReg && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowLoginReg(false);
      }
    };
    if (showLoginReg) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showLoginReg]);

  return (
    <div className="flex flex-col relative">
      <div style={{
        backgroundColor: "#F8F2F3",
        backgroundImage: `url(${BannerImg})`,
        backgroundSize: "cover",
        opacity: 0.6,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
      }}></div>
      <div className="relative flex w-full p-4 sm:justify-between justify-between lg:justify-center xl:justify-center  items-center border-b   border-[#8B24332B] ">
        {(userType === "admin" || userType === "restaurant") ? "" :
          (
            <button className={showLoginReg ? "" : "humbar-log hidden"}
              onClick={() => { setShowLoginReg(!showLoginReg) }}>
              <span className="block w-[25px] h-[2px] bg-black my-[5px]"></span>
              <span className="block w-[25px] h-[2px] bg-black my-[5px]"></span>
              <span className="block w-[25px] h-[2px] bg-black my-[5px]"></span>
            </button>
          )
        }
        <div className="flex items-center justify-center md:gap-4 sm:gap-3 gap-2 " >
          <span onClick={() => { setShowModalReg(false); navigate(`/restaurant/${rest_name}`) }}>
            <img
              src={Meteri_Logo}
              className="sm:w-[160px] w-[100px]   cursor-pointer"
              alt="meteri logo"
            />
          </span>
          {logo && <div className="md:text-3xl sm:text-3xl text-xl"><IoClose /></div>}
          {logo && (
            <span onClick={() => { setShowModalReg(false); navigate(`/restaurant/${rest_name}`) }}>
              <img
                src={logo}
                className="sm:w-[160px] w-[100px] cursor-pointer"
                alt="Restaurant logo"
              />
            </span>
          )}
        </div>
        <div className="sm:relative lg:absolute xl:absolute lg:right-8 flex gap-x-1">

          {/* mobile view sidebar title*/}
          {(userType === "admin" || userType === "restaurant") ? "" :
            (
              <div
                ref={sidebarRef}
                className={`login-reg fixed w-[250px] h-screen top-0 left-0 bg-[#8b2433] sm:hidden flex-col p-[100px_30px] gap-[10px] transition-all duration-500 ease-in-out z-[999] rounded-none  flex rounded-3xl ${showLoginReg ? "" : "-translate-x-full"}`}>
                {isLogin.loginUser && isLogin.token && isLogin.role === "customer"
                  || localStorage.getItem("token") && localStorage.getItem("Role") === "customer" ?
                  <>
                    <div className="relative group">
                      <Link to={`/restaurant/profile/${rest_name}`}
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#9f414f]  rounded-full shadow-sm"
                        onClick={() => { setShowModalLogin(false); setShowModalReg(false); setShowLoginReg(false) }}
                      >
                        <span
                          className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">Profile dd</span>
                        </span>
                      </Link>
                    </div>
                    <div className="relative group">
                      <Link to={`/restaurant/changePassword/${rest_name}`}
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#9f414f]  rounded-full shadow-sm"
                        onClick={() => { setShowModalLogin(false); setShowModalReg(false); setShowLoginReg(false) }}
                      >
                        <span
                          className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">Change Password</span>
                        </span>
                      </Link>
                    </div>
                    <div className="relative group">
                      <button
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#9f414f]  rounded-full shadow-sm"
                        onClick={() => { userLogout(); setShowModalLogin(false); setShowModalReg(false); setShowLoginReg(false) }}
                      >
                        <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">Log Out</span>
                        </span>
                      </button>
                    </div>
                  </> :
                  <>
                    <div className="relative group">
                      <button
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#9f414f]  rounded-full shadow-sm"
                        onClick={() => { setShowModalLogin(true); setShowModalReg(false); setShowLoginReg(false) }}
                      >
                        <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">Login</span>
                        </span>
                      </button>
                    </div>
                    <div className="relative group">
                      <button
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#9f414f]  rounded-full shadow-sm"
                        onClick={() => { setShowModalReg(true); setShowModalLogin(false); setShowLoginReg(false) }}
                      >
                        <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">Register</span>
                        </span>
                      </button>
                    </div>
                  </>
                }
                <MdCancel
                  onClick={() => setShowLoginReg(false)}
                  className="absolute top-3 right-3 w-5 h-5 cancel-btn"
                  color="gray"
                />
              </div>
            )
          }

          {/* desktop view */}
          {(userType === "admin" || userType === "restaurant") ? "" :
            (
              <div className={`destop-login-reg flex items-center justify-between gap-x-1`}>
                {isLogin.loginUser && isLogin.token && isLogin.role === "customer"
                  || localStorage.getItem("token") && localStorage.getItem("Role") === "customer" ?
                  <>
                    <div className="relative group w-full flex justify-end dropdown-container ">
                      {getGreeting() && <span style={{ color: '#8B2433', fontWeight: 'bold' }}>{getGreeting()}</span>}
                      <button className="inline-flex items-center px-2  outline-none" onClick={toggleDropdown}>
                        <RiArrowDownSLine color="#8B2433" className="text-2xl ml-auto" />
                      </button>
                      <div
                        className={`${showOptionToggle ? 'opacity-100 z-50' : 'opacity-0 z-20'}
          bg-[#FAF6F6] h-fit max-h-[320px] border-[#8B2433] overflow-hidden absolute top-[46px] pt-[9px] p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                      >
                        <label
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center gap-[15px] filter_list_btn"
                        >
                          <Link to={`/restaurant/profile/${rest_name}`}
                            className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            Profile
                          </Link>
                        </label>
                        <label
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center gap-[15px] filter_list_btn"
                        >
                          <Link to={`/restaurant/changePassword/${rest_name}`}
                            className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            Change Password
                          </Link>
                        </label>
                        <label
                          className="px-0 py-2 flex align-center gap-[15px] filter_list_btn cursor-pointer"
                          onClick={handleLogout}
                        >
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            Logout
                          </span>
                        </label>
                      </div>
                    </div>
                  </> :
                  <>
                    <div className="relative group">
                      <button
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#8B2433] border border-gray-300 rounded-full shadow-sm"
                        onClick={() => { setShowModalLogin(true); setShowModalReg(false) }}
                      >
                        <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">{t('login')}</span>
                        </span>
                      </button>
                    </div>
                    <div className="relative group">
                      <button
                        className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#8B2433] border border-gray-300 rounded-full shadow-sm"
                        onClick={() => { setShowModalReg(true); setShowModalLogin(false) }}
                      >
                        <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                          <span className="">{t('register')}</span>
                        </span>
                      </button>
                    </div>
                  </>
                }
                <MdCancel
                  onClick={() => setShowLoginReg(false)}
                  className="absolute top-3 right-3 w-5 h-5 cancel-btn"
                  color="gray"
                />
              </div>
            )
          }

          {/* Dropdown */}
          {/* <div className="relative group">
            <button
              className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#8B2433] border border-gray-300 rounded-full shadow-sm"
              onClick={() => setShowOption(!showOption)}
            >
              <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                <img
                  src="https://imgs.search.brave.com/t75I9OP7qXsjqv33_jBrO0T1-9rQz3zK_ZSlSSrxhws/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJpdGFubmljYS5j/b20vNTkvMTc1OS0w/MDQtRjQxNzU0NjMv/RmxhZy1JdGFseS5q/cGc"
                  className="w-5 h-5 rounded-full"
                  alt="flag"
                />{" "}
                <span className="sm:block hidden"> Italiano</span>
              </span>
            </button>
            <div
              id="dropdown-menu"
              className={`${!showOption ? "hidden" : ""
                } absolute right-0 mt-2 rounded-md shadow-lg bg-[#8B2433] text-white p-1 space-y-1 w-[120px]`}
            >
              <a
                href="#"
                className="block px-4 py-2 poppins-regular text-white hover:bg-gray-700 cursor-pointer rounded-md flex items-center gap-3"
              >
                <img
                  src="https://imgs.search.brave.com/t75I9OP7qXsjqv33_jBrO0T1-9rQz3zK_ZSlSSrxhws/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJpdGFubmljYS5j/b20vNTkvMTc1OS0w/MDQtRjQxNzU0NjMv/RmxhZy1JdGFseS5q/cGc"
                  className="w-5 h-5 rounded-full"
                  alt="flag"
                />{" "}
                Italiano
              </a>
              <a
                href="#"
                className="block px-4 py-2 poppins-regular text-white hover:bg-gray-700 cursor-pointer rounded-md flex items-center gap-3"
              >
                <img
                  src="https://imgs.search.brave.com/hmqYLvERmcFW9RCxohSOfxXQWOeA3BLZjMsryPmSA7o/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzFhLzY5/Lzg3LzFhNjk4NzMx/Yjk2YzZhOWIyMDA5/MDVmOTM4ODc4ZWEx/LmpwZw"
                  className="w-5 h-5 rounded-full"
                  alt="flag"
                />{" "}
                English
              </a>
            </div>
          </div> */}
          <LanguageSelection />
        </div>
      </div>

      {
        showModalLogin &&
        <CustomerLogin
          closeModal={() => { setShowModalLogin(false); setShowModalReg(false) }}
          setShowModalLogin={setShowModalLogin}
          setShowModalReg={setShowModalReg}
          restaurantId={restaurantId}
        />
      }

      {
        showModalReg &&
        <CustomerRegister
          closeModal={() => { setShowModalReg(false); setShowModalLogin(false) }}
          setShowModalLogin={setShowModalLogin}
          setShowModalReg={setShowModalReg}
          restaurantId={restaurantId}
        />
      }
      {
        (location.pathname === `/restaurant/${rest_name}` || showSentence === 1) &&
        !showModalReg &&
        location.pathname !== `/restaurant/profile/${rest_name}` &&
        location.pathname !== `/restaurant/changePassword/${rest_name}` && (
          <div className="md:p-12 py-12 sm:p-6 p-[15px] text-center flex flex-col md:gap-7 gap-3 items-center">
            {/* <p className="max-w-[673px] sm:text-lg text-base  tracking-wider">{restaurantName}</p> */}
            <div className="flex justify-around">
              <h1 className=" spinja-font w-full text-left sm:text-[42px] text-[22px] font-medium leading-[26px] text-[#8B2433] uppercase">{restaurantName}</h1>
            </div>
            <p className="max-w-[673px] sm:text-lg text-base  tracking-wider">{t('landingPage.description')}</p>
            {/* <p className="max-w-[673px] sm:text-lg text-base  tracking-wider">In questo ristorante puoi scegliere tra i vini della Selezione Meteri.</p>
            <p className="max-w-[673px] sm:text-lg text-base tracking-wider">Il filo conduttore tra i vini della nostra Selezione è l'artigianalità, il rispetto di territorio e ambiente e la straordinaria godibilità.</p>
            <p className="max-w-[673px] sm:text-lg text-base tracking-wider">Ogni etichetta, ogni bottiglia, ogni sorso rappresentano il racconto di un'esperienza umana legata alla cultura del vino e al rispetto dei luoghi.</p> */}
            <p
              className="max-w-[673px] sm:text-lg text-base tracking-wider"
              dangerouslySetInnerHTML={{ __html: desc?.replace(/\n/g, "<br />") }}
            ></p>
          </div>
        )
      }
    </div >
  );
};

Banner.propTypes = {
  showSentence: PropTypes.bool,
  logo: PropTypes.string,
  desc: PropTypes.string,
  restaurantId: PropTypes.string,
  restaurantName: PropTypes.string,
  showModalReg: PropTypes.bool,
  setShowModalReg: PropTypes.func,
};

export default Banner;
